import { useTheme } from '@/context/ThemeProvider';
import { Moon, Sun } from 'lucide-react';

import { trackThemeChange } from '@/lib/analytics-event';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

// Dropdown to toggle the theme
export function ModeToggle() {
  const { setTheme } = useTheme();

  const handleThemeChange = (theme) => {
    setTheme(theme);
    trackThemeChange(theme);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div
          className='inline-flex h-11 w-11 items-center justify-center bg-background text-gray-400 transition-colors hover:text-primary disabled:pointer-events-none'
          title='Toggle Theme'
        >
          <Sun
            className='h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0'
            title='Light Mode'
          />
          <Moon
            className='absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100'
            title='Dark Mode'
          />
          <span className='sr-only'>Toggle theme</span>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end'>
        <DropdownMenuItem
          onClick={() => handleThemeChange('light')}
          title='Switch to Light Mode'
        >
          Light
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => handleThemeChange('dark')}
          title='Switch to Dark Mode'
        >
          Dark
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => handleThemeChange('system')}
          title='Use System Theme'
        >
          System
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
